import { Component, OnInit, Input, Injectable, ViewChild, ElementRef, Inject, SecurityContext } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { xml2js } from 'xml2js';
import { Marked } from '@ts-stack/markdown';

import {APIURL} from "../../services/url.config";
import {DomSanitizer} from "@angular/platform-browser";
import {RulesService} from "../../services/rules.service";
import {Rule} from "../../services/capd.model";
import { parseString } from 'xml2js';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'capd-client-response',
    templateUrl: './capd-client-response.component.html',
    styleUrls: ['./capd-client-response.component.less']
})
@Injectable()
export class ClientMockResponseComponent implements OnInit {
    @Input() public messageCards: any;
    @Input() public sessionId: any;
    @Input() message: string;
    @Input() authForm: any;
    @Input() urlExtensions: any;

    rawResponse: any;
    displayedCards: any;

    // set url
    url = '';

    // data returned from the get request
    data: any;
    @ViewChild('stickyMenu', { static: false }) menuElement: ElementRef;
    responseData: any;
    bodies: any;
    rules: Rule[];
    isLoadingCards = false;

    // set up all necessary connection tools
    public displayData: string;
    constructor (
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        private _sanitize: DomSanitizer,
        private _rulesService: RulesService
    ) {    }

    // toggle raw JSON data to display
    showRawData() {
        this.displayData = JSON.stringify(this.responseData, undefined, 2);
        const tag = document.getElementById('display');
        if (tag) {
            tag.hidden = false;
        }
    }

    // toggle raw JSON data to hide
    hideRawData() {
        const tag = document.getElementById('display');
        if (tag) {
            tag.hidden = true;
        }
    }

    // toggle summary data to show
    showSumData() {
        const tag = document.getElementById('summary');
        if (tag) {
            tag.hidden = false;
        }
    }

    // toggle summary data to hide
    hideSumData() {
        const tag = document.getElementById('summary');
        if (tag) {
            tag.hidden = true;
        }
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this._rulesService.getRules().then((rules: Rule[]) => {
            this.rules = rules;
        });
    }

    getResponseData() {
        this.isLoadingCards = true;
        // need to remove creds
        // demo
        // make api call
        const headers = new HttpHeaders()
            .set('Authorization',  'Basic ' + btoa(this.authForm.fdUsername + ':' + this.authForm.fdPassword))
            .set('cache-control', 'no-cache, private')
            .set('Content-Type', 'application/json');

        this.url = APIURL + 'capd-client/rest/incnlp/sessions/' + this.sessionId + '/1?' + this.urlExtensions;

        // make api GET request
        return this.http
            .get(this.url, { headers: headers })
            .subscribe(
                (val: any) => {
                    console.log('GET call successful, ', val);
                    parseString(val.response, function (err, result) {
                        console.log(result);
                    });
                    this.responseData = val;
                    this.messageCards = [];
                    this.setData();
                }, response => {
                    console.log('GET call in error', response);
                    this.isLoadingCards = false;
                }, () => {
                    console.log('GET completed.');
                    this.isLoadingCards = false;
                }
            );
    }

    ngOnChanges() {
        if (this.message === 'Submitted') {
            this.getResponseData();
            this.message = 'Updated';
        }

        if (this.message === 'Clear') {
            this.clearResponseData();
            this.message = 'Updated';
        }
    }

    formatOutput() {
        // properly indent JSON output
        const disp = document.getElementById('rawResp');
        return disp.innerText = JSON.stringify(JSON.parse(this.rawResponse), null, '    ');
    }

    private setData() {
        let parsedResponseXML;
        if (this.responseData.response !== null) {
            parseString(this.responseData.response, function (err, result) {
                parsedResponseXML = result;
            });
        } else {
            parsedResponseXML = [];
        }


        this.responseData.response = parsedResponseXML;
        if (this.responseData.response !== null) {


            // get number of entries
            if (typeof this.responseData.response.entries !== undefined) {
                if (typeof this.responseData.response.entries.entry[0] !== undefined) {
                    this.messageCards = new Array(this.responseData.response.entries.entry.length);
                    this.bodies = new Array(this.responseData.response.entries.entry.length);
                }
            }


            // ensure the entry exists
            if (typeof this.responseData.response.entries.entry[0] !== undefined) {
                // iterate through entries adn set values accordingly
                for (let i = 0; i < this.responseData.response.entries.entry.length; ++i) {
                    if (this.responseData.response.entries.entry[i]) {
                        if (!this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:props'][0]['satisfied'] &&
                            this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].code != undefined &&
                            this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].title != undefined &&
                            this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].priority != undefined &&
                            this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:evidence'][0]['mm:code'][0]['$'].displayName != undefined) {
                            // CDI
                            this.messageCards[i] = {
                                triggerNumber: this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].code,
                                status: 'Status Not Provided',
                                title: this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].title,
                                state: 'State Not Provided',
                                priority: this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].priority,
                                body: this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:evidence'][0]['mm:code'][0]['$'].displayName,
                                text: this.responseData.response.entries.entry[i]['mm:alert'][0]['mm:capd'][0]['mm:message'][0]['$'].text,
                                rawJson: JSON.stringify(this.responseData.response.entries.entry[i])
                            };
                        } else {
                            console.log('No satisfied tag - not adding message card.');
                        }
                    }
                }
                // Filter malformed responses from display
                this.messageCards = this.messageCards.filter(r => r.title != null);
                this.messageCards = this.messageCards.filter(r => r.status != null);
                this.messageCards = this.messageCards.filter(r => r.triggerNumber != null);
                this.messageCards = this.messageCards.filter(r => r.state != null);
                this.messageCards = this.messageCards.filter(r => r.priority != null);
                this.messageCards = this.messageCards.filter(r => r.body != null);
                this.displayedCards = this.messageCards;

                this.displayedCards.forEach(displayCard => {
                    displayCard.rule = this.rules.find(rule => {
                        return rule.triggerCode === displayCard.triggerNumber;
                    })
                });
            }
        }
    }

    clearResponseData() {
        this.responseData = null;
        this.messageCards = null;
        this.displayedCards = null;
        this.displayData = null;
    }

    CopyToClipboard() {
        const range = document.createRange();
        range.selectNode(document.getElementById('summary'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
    }

    searchCDSResponses() {
        let input = (<HTMLInputElement>document.getElementById('searchCDSResponse')).value;
        let filteredList = [];

        if (input != null && input != '' && input != undefined) {
            input = input.toLowerCase().trim();
            for (let i = 0; i < this.messageCards.length; i++) {
                let title = '';
                if (this.messageCards[i].title) {
                    title = this.messageCards[i].title.toLowerCase().trim();
                }
                let triggerNumber = '';
                if (this.messageCards[i].triggerNumber) {
                    triggerNumber = this.messageCards[i].triggerNumber.toLowerCase().trim();
                }
                let messageText = '';
                if(this.messageCards[i].rule && this.messageCards[i].rule.action && this.messageCards[i].rule.action.messageText) {
                    messageText = this.messageCards[i].rule.action.messageText.toLowerCase().trim();
                }
                let messageTitle = '';
                if (this.messageCards[i].rule && this.messageCards[i].rule.action && this.messageCards[i].rule.action.messageTitle) {
                    messageTitle = this.messageCards[i].rule.action.messageTitle.toLowerCase().trim();
                }

                if (title.includes(input) ||
                    triggerNumber.includes(input) ||
                    messageText.includes(input) ||
                    messageTitle.includes(input))
                    filteredList.push(this.messageCards[i]);
            }
            this.displayedCards = filteredList;
        }
        else {
            this.displayedCards = this.messageCards;
        }

    }

    /**
     * Parses the message of the card, both using HTML and Markdown with safe sanitization.
     *
     * @func messageParse
     * @param {string} toParse - the raw text to parse into a displayable message.
     * @returns {string} the safely sanitized message.
     */
    messageParse(toParse: string) {
        if (!!toParse) {
            const markdownHtml = Marked.parse(toParse);
            return this._sanitize.sanitize(SecurityContext.HTML, markdownHtml);
        }
    }

    /**
     * Parses the title for the card, using Angular's safe sanitization.
     *
     * @func titlePase
     * @param {string} toParse - the raw text to parse into a displayable title.
     * @returns {string} the safely sanitized title.
     */
    titleParse(toParse: string) {
        if (!!toParse) {
            return this._sanitize.sanitize(SecurityContext.HTML, toParse);
        }
    }
}
